export const DEFAULT_INTERVAL = 5

export const START_TIME_FORMAT = 'HH:mm'



// WEBPACK FOOTER //
// ./src/constants/flights.ts